// Complete Web Audio bridge for react-native-sound-player
const listeners = {
  FinishedPlaying: new Set(),
  FinishedLoading: new Set(),
  FinishedLoadingURL: new Set(),
  FinishedLoadingFile: new Set(),
};

const activeAudios = new Set();
let currentAudio = null;

const SoundPlayer = {
  playSoundFile: (fileName, fileType) => {
    if (typeof Audio === "undefined") return;
    try {
      const ext = fileType
        ? fileType.startsWith(".")
          ? fileType
          : `.${fileType}`
        : fileName.includes(".")
        ? ""
        : ".mp3";
      const src = `/${fileName}${ext}`;
      const audio = new Audio(src);

      currentAudio = audio;
      activeAudios.add(audio);

      audio.onended = () => {
        activeAudios.delete(audio);
        if (currentAudio === audio) {
          currentAudio = null;
        }
        listeners.FinishedPlaying.forEach((cb) => {
          try {
            cb({ success: true });
          } catch (e) {}
        });
      };

      audio.onerror = () => {
        activeAudios.delete(audio);
        if (currentAudio === audio) {
          currentAudio = null;
        }
        listeners.FinishedPlaying.forEach((cb) => {
          try {
            cb({ success: false });
          } catch (e) {}
        });
      };

      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          activeAudios.delete(audio);
        });
      }
    } catch (err) {
      console.warn("SoundPlayer playSoundFile error:", err);
    }
  },

  playUrl: (url) => {
    if (typeof Audio === "undefined") return;
    try {
      const audio = new Audio(url);
      currentAudio = audio;
      activeAudios.add(audio);

      audio.onended = () => {
        activeAudios.delete(audio);
        if (currentAudio === audio) {
          currentAudio = null;
        }
        listeners.FinishedPlaying.forEach((cb) => {
          try {
            cb({ success: true });
          } catch (e) {}
        });
      };

      audio.onerror = () => {
        activeAudios.delete(audio);
        listeners.FinishedPlaying.forEach((cb) => {
          try {
            cb({ success: false });
          } catch (e) {}
        });
      };

      const playPromise = audio.play();
      if (playPromise !== undefined) {
        playPromise.catch(() => {
          activeAudios.delete(audio);
        });
      }
    } catch (err) {}
  },

  loadSoundFile: () => {},
  loadUrl: () => {},
  play: () => {
    if (currentAudio) {
      currentAudio.play().catch(() => {});
    }
  },
  pause: () => {
    activeAudios.forEach((audio) => {
      try {
        audio.pause();
      } catch (e) {}
    });
  },
  resume: () => {
    if (currentAudio) {
      currentAudio.play().catch(() => {});
    }
  },
  stop: () => {
    activeAudios.forEach((audio) => {
      try {
        audio.pause();
        audio.currentTime = 0;
      } catch (e) {}
    });
    activeAudios.clear();
    currentAudio = null;
  },
  seek: (seconds) => {
    if (currentAudio) {
      currentAudio.currentTime = seconds;
    }
  },
  setVolume: (vol) => {
    activeAudios.forEach((audio) => {
      try {
        audio.volume = Math.max(0, Math.min(1, vol));
      } catch (e) {}
    });
  },
  getInfo: async () => ({
    currentTime: currentAudio ? currentAudio.currentTime : 0,
    duration: currentAudio ? currentAudio.duration : 0,
  }),
  addEventListener: (eventName, callback) => {
    if (listeners[eventName] && typeof callback === "function") {
      listeners[eventName].add(callback);
      return {
        remove: () => {
          listeners[eventName].delete(callback);
        },
      };
    }
    return { remove: () => {} };
  },
  onFinishedPlaying: (callback) => {
    return SoundPlayer.addEventListener("FinishedPlaying", callback);
  },
  onFinishedLoading: (callback) => {
    return SoundPlayer.addEventListener("FinishedLoading", callback);
  },
};

module.exports = SoundPlayer;
module.exports.default = SoundPlayer;
